import theme from '../theme/index.js';
import { mergeThemeOverride } from '@chakra-ui/react';

/**
 * extendTheme
 *
 * Function to override or customize the design system theme conveniently.
 * First extension overrides the baseTheme and following extensions override the preceding extensions.
 *
 * @example:
 * const customTheme = extendTheme(
 *   {
 *     colors: {
 *       red: {
 *         400: "#b4d455",
 *       },
 *     },
 *   },
 * )
 *
 */
var extendTheme = function extendTheme() {
  for (var _len = arguments.length, overrides = new Array(_len), _key = 0; _key < _len; _key++) {
    overrides[_key] = arguments[_key];
  }
  return mergeThemeOverride.apply(void 0, [theme].concat(overrides));
};
var extendTheme$1 = extendTheme;
export { extendTheme$1 as default };